import {ExperimentalLink} from "../ExperimentalLink";
import classes from "./WidgetCard.module.css";

interface WidgetCardProps {
    title?: string;
    titleUrl?: string | null;
    description?: string;
    children: React.ReactNode;
}

export function WidgetCard({
    title,
    titleUrl,
    description,
    children,
}: WidgetCardProps) {
    return (
        <div className={classes.card}>
            {description && (
                <div className={classes.description}>
                    {titleUrl ? (
                        <ExperimentalLink
                            href={titleUrl}
                            style={{
                                textDecoration: "underline",
                                color: "inherit",
                            }}
                        >
                            {description}
                        </ExperimentalLink>
                    ) : (
                        description
                    )}
                </div>
            )}
            {children}
        </div>
    );
}
